export var attributes = {
  email: 'E-mail',
  current_password: 'Current password',
  password: 'Password',
  confirm_password: 'Password confirm'
};